import FacebookIcon from "../../../assets/svg/FacebookIcon";
import LinkedinIcon from "../../../assets/svg/LinkedinIcon";
import XIcon from "../../../assets/svg/XIcon";
import InstagramIcon from "../../../assets/svg/InstagramIcon";

export const socialMediaPlatforms = [
  {
    name: "LinkedIn",
    icon: <LinkedinIcon color={"#186CAA"} bgColor={"white"} />,
    url: (propertyUrl) =>
      `https://www.linkedin.com/shareArticle?mini=true&url=${propertyUrl}`,
    bgColor: "#186CAA"
  },
  {
    name: "Twitter",
    icon: <XIcon color={"black"} bgColor={"white"} />,
    url: (propertyUrl) => `https://twitter.com/intent/tweet?url=${propertyUrl}`,
    bgColor: "black"
  },
  {
    name: "Instagram",
    icon: <InstagramIcon color={"white"} bgColor={"transparent"} />,
    url: (propertyUrl) => `https://www.instagram.com/?url=${propertyUrl}`,
    bgColor:
      "radial-gradient(127.77% 127.77% at 14.93% 100.35%, #FFB140 0%, #FF5445 25.59%, #FC2B82 59.9%, #8E40B7 100%)"
  },
  {
    name: "Facebook",
    icon: <FacebookIcon color={"#2D66ED"} bgColor={"white"} />,
    url: (propertyUrl) =>
      `https://www.facebook.com/sharer/sharer.php?u=${propertyUrl}`,
    bgColor: "#2D66ED"
  }
];
